import { Box, Button, TextField, Typography, Select } from "@mui/material";
import { styled } from "@mui/material/styles";

export const fullContainerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "16px",
  border: "1px solid #183059",
};

export const FormContainer = styled(Box)(() => ({
  backgroundColor: "#E8EAEE",
  borderRadius: "10px",
  padding: "24px",
  marginBottom: "20px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  position: "relative",
}));

export const MapContainer = styled(Box)(() => ({
  width: "100%",
  height: "500px",
  backgroundColor: "#f0f0f0",
  borderRadius: "10px",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #ddd",
  overflow: "hidden",
}));

export const StyledTextField = styled(TextField)(({ error }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: "16px",
    height: "55px",
    "& fieldset": {
      borderColor: error ? "#cc0000" : "#183059",
      borderWidth: "2px",
    },
    "&:hover fieldset": {
      borderColor: error ? "#cc0000" : "#183059",
    },
    "&.Mui-focused fieldset": {
      borderColor: error ? "#cc0000" : "#183059",
    },
    "&.Mui-disabled": {
      backgroundColor: "#B7BFCC",
      color: "#FFF",
      "& fieldset": {
        border: "none",
      },
    },
    "&.Mui-disabled .MuiOutlinedInput-input": {
      color: "#FFF",
      WebkitTextFillColor: "#FFF",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "16px 24px",
  },
}));

export const StyledSelect = styled(Select)(({ error }) => ({
  backgroundColor: "#FFFFFF",
  borderRadius: "16px",
  height: "55px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: error ? "#cc0000" : "#183059",
    borderWidth: "2px",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: error ? "#cc0000" : "#183059",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: error ? "#cc0000" : "#183059",
  },
  "& .MuiSelect-select": {
    padding: "16px 24px",
  },
  "&.Mui-disabled": {
    backgroundColor: "#B7BFCC",
    color: "#FFF",
    "& fieldset": {
      border: "none",
    },
  },
}));

export const ConfirmButton = styled(Button)(() => ({
  backgroundColor: "#F9E719",
  color: "#1F242E",
  height: "55px",
  border: "1px solid #414958",
  borderRadius: "8px",
  padding: "16px 24px",
  fontWeight: "bold",
  textTransform: "none",
  fontSize: "20px",
  "&:hover": {
    backgroundColor: "#FBC02D",
  },
}));

export const CancelButton = styled(Button)(() => ({
  backgroundColor: "#F2F2F3",
  height: "55px",
  borderRadius: "8px",
  padding: "16px 24px",
  fontWeight: "bold",
  border: "1px solid #414958",
  color: "#1F242E",
  fontSize: "20px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#F2F2F3",
  },
}));

export const DeleteButton = styled(Button)(() => ({
  color: "#cc0000",
  height: "55px",
  borderRadius: "8px",
  padding: "16px 24px",
  fontSize: "20px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgba(204, 0, 0, 0.05)",
  },
}));

export const ImageUploadBox = styled(Box)(() => ({
  border: "2px dashed #183059",
  width: "180px",
  height: "180px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  overflow: "hidden",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#e8e8e8",
  },
}));

export const ErrorText = styled(Typography)(() => ({
  color: "#cc0000",
  fontSize: "12px",
  marginTop: "4px",
  marginLeft: "14px",
}));
